const BIT_COUNT = 3;

export const ORDERSTATE_PREPPING = 0;
export const ORDERSTATE_IGNORE = 7;

export function getInitialState(printersState) {
  let printersStateWork = [];
  let kitchenIds = Array.from(new Set(printersState.map(ps => ps.kitchen_id)));
  kitchenIds.forEach(kitchenId => {
    let atLeastOnePrinted = printersState.some(
      printerState => printerState.kitchen_id == kitchenId && printerState.printed
    );
    printersStateWork.push({
      kitchen_id: kitchenId,
      printed: atLeastOnePrinted
    })
  });
  let result = 0;
  printersStateWork.forEach(printerState => {
    let orderState = printerState.printed
      ? ORDERSTATE_PREPPING
      : ORDERSTATE_IGNORE;
    let state = orderState << (printerState.kitchen_id * BIT_COUNT);
    result |= state;
  });
  return result;
}
